/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	MentorshipDTO,
	MentorshipDTOFromJSON,
	MentorshipDTOFromJSONTyped,
	MentorshipDTOToJSON,
} from "./MentorshipDTO";

/**
 *
 * @export
 * @interface MentorshipDTOPagedResponse
 */
export interface MentorshipDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<MentorshipDTO>}
	 * @memberof MentorshipDTOPagedResponse
	 */
	data?: Array<MentorshipDTO> | null;
}

export function MentorshipDTOPagedResponseFromJSON(
	json: any
): MentorshipDTOPagedResponse {
	return MentorshipDTOPagedResponseFromJSONTyped(json, false);
}

export function MentorshipDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): MentorshipDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(MentorshipDTOFromJSON),
	};
}

export function MentorshipDTOPagedResponseToJSON(
	value?: MentorshipDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(MentorshipDTOToJSON),
	};
}
